import { API_URLS } from '../constants/apiUrls';
import axiosClient from './axiosClient';

const authAPI = {
  login: (credentials: { username: string; password: string }) => {
    return axiosClient.post(`${API_URLS.LOGIN}`, credentials);
  },
};

export default authAPI;
